import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../../../../styles/scss/style.css';
import AnswerBuilderComponent from './AnswerBuilder'

class AnswerBuilder extends Component {
	static propTypes = {
		data: PropTypes.arrayOf(PropTypes.string).isRequired
	};
	state = { reactions: [ ...this.props.data, '' ], placeholder: 'Enter bot answer' };
	getLengthFromEnd = (arr, i) => arr.length-i < 0 ? 1 : arr[arr.length - i].length; // If the length becomes -1 needs to return 1 instead
	updateAnswersList = () => {
		const { reactions } = this.state;
		if (!this.getLengthFromEnd(reactions, 2)) {
			reactions.pop();
			this.setState({ reactions });
		}
		if (this.getLengthFromEnd(reactions, 1)) {
			reactions.push('');
			this.setState({ reactions });
		}
	};
	removeReaction = (i) => {
		let { reactions } = this.state;
		reactions.splice(i, 1);
		this.setState({ reactions }, () => {
			const newData = {
				reactions: this.state.reactions.slice(0, this.state.reactions.length - 1)
			};

			this.props.handleSave(this.props.id, newData);
		});
	};
	handleChange = ({ target }) => {
		let { [target.id]: arr } = this.state;
		arr[target.name] = target.value;
		this.setState({ [target.id]: arr }, () => this.updateAnswersList());
	};

	handleBlur = (e) => {
		if (!e.target.value) return

		const newData = {
			reactions: this.state.reactions.slice(0, this.state.reactions.length - 1)
		};

		this.props.handleSave(this.props.id, newData);
	}

	render() {
		if (!this.props.data) return <span>Loading data</span>;
		return <AnswerBuilderComponent {...this.state} handleChange={this.handleChange} handleBlur={this.handleBlur} removeReaction={this.removeReaction} />;
	};
};

export default AnswerBuilder;



// WEBPACK FOOTER //
// ./src/redux/components/organisms/AnswerBuilder/index.js